import { render, staticRenderFns } from "./RemoveUser.vue?vue&type=template&id=60983835&scoped=true&lang=pug"
import script from "./RemoveUser.vue?vue&type=script&lang=js"
export * from "./RemoveUser.vue?vue&type=script&lang=js"
import style0 from "./RemoveUser.vue?vue&type=style&index=0&id=60983835&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60983835",
  null
  
)

export default component.exports